import { render, staticRenderFns } from "./LabelComponent.vue?vue&type=template&id=c0cdc974&scoped=true&"
import script from "./LabelComponent.vue?vue&type=script&lang=js&"
export * from "./LabelComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0cdc974",
  null
  
)

export default component.exports